import styled from 'styled-components'
import { media } from '../../../layouts/utils'
import {
    borderRadius,
    colorBrandPrimary,
    colorNeutral,
    colorNeutralDark,
    fontFamily,
    shadow,
} from '../../../global.style'

export const CardContainer = styled.div`
    width: 422px;
    height: 232px;
    border-radius: ${borderRadius.md};
    background-color: ${colorNeutral.light};
    box-shadow: ${shadow.level1};
    padding: 32px;

    ${media.desktop`
        width: 328px;
        min-height: 232px;
    `}
`

export const CardTitle = styled.h3`
    padding: 0;
    width: 422px;
    margin-bottom: 8px;
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.brand};
    font-size: 20px;
    letter-spacing: 0;
    line-height: 26px;
    font-weight: normal;

    ${media.desktop`
        max-width: 328px;
     `}
`

export const CardText = styled.span`
    max-width: 422px;
    color: ${colorNeutralDark['90']};
    font-family: ${fontFamily.neutral};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 21px;

    ${media.desktop`
        font-size: 14px;
    `}
`
export const CardBotao = styled.div`
    margin-top: 24px;
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: ${({ alinhamento }) =>
        alinhamento === 'Início'
            ? `flex-start`
            : alinhamento === 'Fim'
            ? `flex-end`
            : `center`};
    align-items: center;
`
